const kraReportRoute = {
    BASE_PATH: "/reports/kra-report",
}

export default kraReportRoute;